<div class="container-box shadow">
  <ul>
    <li>
      <div>
        <div>
          <img [src]="channelNames.AirBnBV2API | channelIcon" alt="" class="channel-icon" />
        </div>
        <div class="stats-info">
          {{ data?.averageRating?.[sources.Airbnb]?.channelAverageRating || 0 | number: '0.1-2'}}
          <div class="count">
            {{ data?.averageRating?.[sources.Airbnb]?.reviewsCount || 0 }} <ng-container i18n>Reviews</ng-container>
          </div>
        </div>
      </div>
    </li>
    <li>
      <div>
        <div>
          <img [src]="channelNames.BookingAPI | channelIcon" alt="" class="channel-icon" />
        </div>
        <div class="stats-info">
          {{ data?.averageRating?.[sources.BookingCom]?.channelAverageRating || 0 | number: '0.1-2'}}
          <div class="count">
            {{ data?.averageRating?.[sources.BookingCom]?.reviewsCount || 0 }} <ng-container i18n>Reviews</ng-container>
          </div>
        </div>
      </div>
    </li>
    <li>
      <div>
        <div>
          <img [src]="channelNames.ExpediaAPI | channelIcon" alt="" class="channel-icon" />
        </div>
        <div class="stats-info">
          {{ data?.averageRating?.[sources.Expedia]?.channelAverageRating || 0 | number: '0.1-2'}}
          <div class="count">
            {{ data?.averageRating?.[sources.Expedia]?.reviewsCount || 0 }} <ng-container i18n>Reviews</ng-container>
          </div>
        </div>
      </div>
    </li>
    <li>
      <div>
        <div>
          <img [src]="channelNames.Homeaway | channelIcon" alt="" class="channel-icon" />
        </div>
        <div class="stats-info">
          {{ data?.averageRating?.[sources.Vrbo]?.channelAverageRating || 0 | number: '0.1-2'}}
          <div class="count">
            {{ data?.averageRating?.[sources.Vrbo]?.reviewsCount || 0 }} <ng-container i18n>Reviews</ng-container>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>
